<template>
  <div class="attachments">
    <div class="input-wrap">
      <p class="text flex">
        <img src="@/assets/images/attach-icon.svg" alt="">
        <span>{{ title }}</span>
         <span v-if="required" class="required">*</span>
      </p>
      <input type="text" class="input" :placeholder="$t('ATTACHMENTS_NAME')"  v-model="attachmentName">
    </div>
    <div class="double-wrap attachment">
    <button class="attach-file" @click="openUppy" v-if="!uploadedAttachmentFile">
      {{ $t("ADD_FILE") }}
    </button>
    <div v-else class="uploaded-attachment input">
       <img :src="uploadedFileIcon" class="file-icon"/>
      <span class="attachment-name">{{attachmentName}}</span>
    </div>
    <template v-if="uploadedAttachmentFile">
      <button class="delete" @click="deleteAttachedFile">
        <img src="@/assets/images/trash_icon.svg" alt="delete" class="delete-icon">
      </button>
      <button class="change-file" @click="openUppy">
        <img src="@/assets/images/return_arrow_icon.svg" class="return-icon"/>
        <span class="text-change-file">{{ $t("CHANGE_FILE") }}</span>
      </button>
    </template>
    <div class="wrapper" v-else>
      <span class="or">
        {{ $t("OR") }}
      </span>
      <div class="input-url-wrap">
        <div class="input-url-wrap-inner">
          <input type="text" class="input" :placeholder="$t('URL_ADDRESS')" :class="{ error: !isValidUrl }"
                  v-model="addedUrl" @keyup="isValidUrl = true" @blur="checkUrlValid">
          <span v-if="!isValidUrl" class="error-text">  {{ '*' + $t("URL_INVALID") }}</span>
        </div>
      </div>
        <!-- the add attachments button appears twice do to design necessities -->
    </div>
  </div>
    <div class="buttons-wrap attachment">
      <button class="add-button" @click="addAttachment" :disabled="( !isValidUrl || !addedUrl ) && !uploadedAttachmentFile">
        {{ $t("ADD") }}
      </button>
    </div>
    <div class="attached-file" v-for="attachment, index in addedAttachments" :key="index">
        <a @click="openContentInNewWindow(attachment.url)" class="uploaded-attachment">
          <img :src="getIconOfAttachment(attachment.url)" @error="imageLoadOnError" class="file-icon"/>
          <span class="attachment-name">{{attachment.name}}</span>
        </a>
        <button class="delete" @click="deleteAttachment(index)">
          <img src="@/assets/images/trash_icon.svg" alt="delete" class="delete-icon" >
        </button>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { getFileTypeIcon, isUrlValid, getIconOfUrl } from '@/utilityFunctions'

export default {
  name: 'add-attachment-field',
  props: {
    uploadedAttachmentFile: {
      type: String,
      required: false,
      default: null
    },
    title: {
      type: String,
      required: false,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    addedAttachments: {
      type: Array,
      required: false,
      default: null
    },
    fieldKey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      attachmentName: null,
      addedUrl: null,
      isValidUrl: true
    }
  },
  computed: {
    uploadedFileIcon () {
      return getFileTypeIcon(this.uploadedAttachmentFile.substring(this.uploadedAttachmentFile.lastIndexOf('.') + 1, this.uploadedAttachmentFile.length))
    }
  },
  methods: {
    ...mapActions(['resetUploadAttachment', 'setFieldKeyForAttachments']),
    openUppy () {
      this.setFieldKeyForAttachments(this.fieldKey)
      this.$emit('openUppy', 'attachment')
    },
    addAttachment () {
      const url = this.uploadedAttachmentFile ? this.uploadedAttachmentFile : this.addedUrl
      if (url) {
        this.$emit('addAttachment', { name: this.attachmentName, url: url })
        this.attachmentName = null
        this.addedUrl = null
        this.isValidUrl = true
      }
    },
    openContentInNewWindow (url) {
      window.open(url)
    },
    deleteAttachedFile () {
      this.resetUploadAttachment(this.fieldKey)
    },
    deleteAttachment (index) {
      this.$emit('deleteAttachment', index)
    },
    checkUrlValid () {
      this.isValidUrl = isUrlValid(this.addedUrl)
    },
    getIconOfAttachment (attachmentUrl) {
      return getIconOfUrl(attachmentUrl)
    },
    imageLoadOnError (e) {
      e.target.src = require('@/assets/images/fileTypeIcons/file.svg')
    }
  }
}
</script>

<style lang="scss" scoped>
.input:disabled{
  background: gray;
}
.uploaded-attachment{
  display: flex; align-items: center; gap: 5px; border-radius: 3px; border: 2px solid #B7B7B7; padding: 5px;
  margin-top: 15px; width: 268px;
  .attachment-name{max-width: unset;}
}
.file-icon{width: 20px;}
.delete-icon{
  height: 20px;
}
.text-change-file{
  font-size: 0.85rem; white-space: nowrap;
}
.delete-icon{
  opacity: 0.8;
  &:hover{opacity: 1;}
}
.attached-file{
  display: flex; align-items: baseline;
  .delete-icon{
    margin-inline-start: 10px;
  }
}
.buttons-wrap.attachment{margin-top: 15px; padding-bottom: 0; margin-bottom: 10px;}
.attachment-name{
  overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 94%; max-width: 150px;
}
.wrapper{
  display: flex; align-items: end; width: 100%;
}
.or{margin-inline: 10px;}
.input-url-wrap{
  width: 100%;
  &-inner{
    position: relative;
    .error-text{
      position: absolute;
    }
  }
}

</style>
